import { useSolicitudesAdministrador } from "./useSolicitudesAdministrador";
import { ModalContractualesAdmin } from "../modalForm/modalForm2";
import Datatable from "../../components/ui/datatable/Datatable";

export const SolicitudesAdministrador = () => {
  const { fetchTableData, columnsDef, setSelectedRows, objModalAdmin, visible, hideModal, refreshToggle } = useSolicitudesAdministrador();

  return (
    <>
      <ModalContractualesAdmin data={objModalAdmin} show={visible} hideModal={hideModal} tamanio="xl" />
      <div className="container-fluid py-4" style={{ padding: "20px", marginTop: "-20px" }}>
        <Datatable
          refreshToggle={refreshToggle}
          storageKey="test-solicitudes-table"
          titletable="Solicitudes en curso"
          requestDataFn={fetchTableData}
          initialPerPage={10}
          columns={columnsDef}
          orderColumns={true}
          adjustColumnSize={true}
          searchEnabled={true}
          searchColumnsEnabled={true}
          columnSelectorEnabled={true}
          checkboxColumn={false}
          rowIdField="id"
          manualPageInput={false}
          rowsPerPageOptions={[10, 15, 20, 25, 30]}
          initialSortBy="fecha_inicio_cambio"
          initialSortDir="desc"
          onSelectionChange={setSelectedRows}
        />
      </div>
    </>
  );
};
